import $ from 'jquery';

/**
 * @desc Manages Google's calendar (Fixtures calendar).
 */
// TODO: Move magic css classes to a config object
export default class GoogleCalendar {
  constructor({
    authorizeButtonSelector = '.js-google-sign-in',
    addToCalendarButtonSelector = '.js-google-add-calendar',
    successMessageSelector = '.js-success-message',
    subscriptionWrapperSelector = '.idm-google-subscription-wrapper',
    discoveryDocs = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
    scopes = 'email https://www.googleapis.com/auth/calendar',
  } = {}) {
    this.discoveryDocs = discoveryDocs;
    this.scopes = scopes;

    this.$authorizeButton = $(authorizeButtonSelector);
    this.$addToCalendarButton = $(addToCalendarButtonSelector);
    this.$successMessageBlock = $(successMessageSelector);
    this.$subscriptionWrapper = $(subscriptionWrapperSelector);

    this.init();
  }

  static signIn() {
    window.gapi.auth2.getAuthInstance().signIn();
  }

  static signOut() {
    window.gapi.auth2.getAuthInstance().signOut();
  }

  init() {
    this.isInitialized = true;

    if (!this.$authorizeButton.length || !this.$addToCalendarButton.length) {
      this.isInitialized = false;

      return;
    }

    // TODO: Move retrieving of data to a separate method
    this.apiKey = this.$authorizeButton.data('google-api-key');
    this.clientId = this.$authorizeButton.data('google-client-id');
    this.calendarId = this.$addToCalendarButton.data('google-calendar-id');

    // Load the API client and auth2 library
    window.gapi.load('client:auth2', () => this.initClient());
  }

  // TODO: Add error handling
  async initClient() {
    try {
      await window.gapi.client.init({
        apiKey: this.apiKey,
        discoveryDocs: this.discoveryDocs,
        clientId: this.clientId,
        scope: this.scopes,
      });
    } catch (e) {
      console.error('Error: ', e.error, ', Details: ', e.details);

      throw e;
    }

    // Listen for sign-in state changes.
    window.gapi.auth2.getAuthInstance()
      .isSignedIn.listen((isSignedIn) => this.updateSignInStatus(isSignedIn));

    // Handle the initial sign-in state.
    this.handleInitialSignInStatus(window.gapi.auth2.getAuthInstance().isSignedIn.get());

    this.$authorizeButton.removeAttr('disabled');
    this.$addToCalendarButton.removeAttr('disabled');

    this.$authorizeButton.click(GoogleCalendar.signIn);
    this.$addToCalendarButton.click(GoogleCalendar.signOut);
  }

  updateSignInStatus(isSignedIn) {
    if (isSignedIn) {
      this.$authorizeButton.addClass('is-hidden');
      this.$addToCalendarButton.removeClass('is-hidden');

      this.addToCalendar();
    } else {
      this.$authorizeButton.removeClass('is-hidden');
      this.$addToCalendarButton.addClass('is-hidden');
    }
  }

  handleInitialSignInStatus(isSignedIn) {
    if (isSignedIn) {
      this.$authorizeButton.addClass('is-hidden');
      this.$addToCalendarButton.removeClass('is-hidden');
    } else {
      this.$authorizeButton.removeClass('is-hidden');
      this.$addToCalendarButton.addClass('is-hidden');
    }
  }

  // TODO: Add error handling
  async addToCalendar() {
    await window.gapi.client.calendar.calendarList.insert({ id: this.calendarId });

    this.$subscriptionWrapper.addClass('is-hidden');
    this.$successMessageBlock.removeClass('is-hidden');

    GoogleCalendar.signOut();
  }
}
